import { css } from '@emotion/react';
import { graphql } from 'gatsby';
import React from 'react';
import StyledAccordion from '../../../atoms/styled-accordion';
import Container from '../../../atoms/Container';
import { colors } from '../../../primitives/colors';
import { StyledButtonAsLink } from '../../../primitives/styled-button';
import paddingDefault from '../../../utils/paddingDefault';
import { breakpoints } from '../../../primitives/tokens';
import { FaqsData } from '../types/faqsTypes';

const styles = {
    backgroundLight: css({
        backgroundColor: 'transparent',
    }),
    backgroundDark: css({
        backgroundColor: colors.shadesBlack,
    }),
    buttonWrap: css({
        display: 'flex',
        marginTop: '48px',
        [breakpoints.mb]: {
            marginTop: '40px',
        },
    }),
    accordionWrap: css({
        paddingRight: '64px',
        paddingLeft: '80px',
        marginBottom: '8px',
        [breakpoints.mb]: {
            paddingRight: '0',
            paddingLeft: '0',
        },
    }),
};

const Faqs = ({ settings, link, headline, byline, questions }: FaqsData): JSX.Element => {
    const { darkMode } = settings;
    const transformedData = {
        settings,
        heading: headline,
        byline,
        questions,
    };

    return (
        <div css={[paddingDefault(), darkMode ? styles.backgroundDark : styles.backgroundLight]}>
            <Container>
                <div css={styles.accordionWrap}>
                    <StyledAccordion
                        faqs={transformedData}
                        onDark={darkMode}
                    />
                    {link?.href && (
                        <div css={styles.buttonWrap}>
                            <StyledButtonAsLink to={link.href}>{link.title}</StyledButtonAsLink>
                        </div>
                    )}
                </div>
            </Container>
        </div>
    );
};

export const query = graphql`
  fragment FaqsData on CmsPageBuilderBlocks {
    faqs {
      settings {
        dark_mode
      }
      link {
        href
        title
      }
      headline
      byline
      questions {
        questions {
          question
          answer
        }
      }
    }
  }
`;

export default Faqs;
